import React from "react";
import "./feature.css";

const Feature = ({ title, text, img, styles_ }) => (
  <article className="scrobits__features-container__feature">
    <div className="scrobits__features-container__feature-title">
      <div />
      <h1>{title}</h1>
      <img src={img} alt="" />
    </div>
    <div className="scrobits__features-container_feature-text">
      <p>{text}</p>
    </div>
  </article>
);

export default Feature;
